import { render, staticRenderFns } from "./ChangeInPerformance.vue?vue&type=template&id=167a8810&scoped=true"
import script from "./ChangeInPerformance.vue?vue&type=script&lang=js"
export * from "./ChangeInPerformance.vue?vue&type=script&lang=js"
import style0 from "./ChangeInPerformance.vue?vue&type=style&index=0&id=167a8810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a8810",
  null
  
)

export default component.exports